import styled from "styled-components";

export const VehicleDetailsNICContainer = styled.div``;

export const HeaderContainer = styled.div``;

export const BackButton = styled.div`
  cursor: pointer;
`;
